// extracted by mini-css-extract-plugin
module.exports = {"formItem":"Select_formItem___PKU0"};